































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import FilterUserComponent from '@/components/filterUser.vue';

@Component({
  components: {
    FilterUserComponent
  }
})
export default class UserListPage extends Vue {
  account = this.$store.state.account;
  application = this.$store.state.application;
  lookup = this.$store.state.lookup;
  dialog = false;
  facultyDialog = false;
  editedItem = { responsibleFacultyId: null };
  editedIndex = -1;
  newFaculty = null;
  disabledNotifications = [];
  autocompleteSearch = '';

  get headers() {
    return [
      { text: this.$t('user.workforceId'), value: 'workforceId', sortable: false, width: '10%' },
      { text: this.$t('user.userName'), value: 'userName', width: '15%' },
      { text: this.$t('user.name'), value: 'name', sortable: false, width: '30%' },
      { text: this.$t('user.responsibleFaculty'), value: 'faculty', sortable: false, width: '30%' },
      { text: this.$t('user.universityRole'), value: 'universityRole', sortable: false, width: '5%' },
      { text: this.$t('user.isActive'), value: 'isActive', sortable: false, width: '5%' }
    ];
  }

  get users(): [] {
    return this.$store.getters['account/getUsers']();
  }

  get totalCount(): [] {
    return this.$store.getters['account/getTotalCount']();
  }

  onPage(page: number): void {
    this.account.search.actualPage = page;
    this.loadUsers();
  }
  onSort(field: any): void {
    this.account.search.orderBy = field[0];
    this.loadUsers();
  }
  onSortDesc(desc: any): void {
    this.account.search.orderByAsc = !desc[0];
    this.loadUsers();
  }
  onItemsPerPage(field: any): void {
    this.account.search.pageRows = field === -1 ? this.account.totalCount : field;
    this.loadUsers();
  }

  setFilter(event: any) {
    this.account.search.filter = event;

    this.loadUsers();
  }

  created(): void {
    this.loadUsers();
    this.$store.dispatch('lookup/getAvailableLookup', 6);
  }

  loadUsers(): void {
    const searchQuery = this.account.search;

    this.$store.dispatch('account/getAll', searchQuery);
  }

  editItem(item: any) {
    this.editedIndex = this.account.users.indexOf(item);
    this.editedItem = JSON.parse(JSON.stringify(item));
    this.editedItem.responsibleFacultyId = item.responsibleFaculty?.key;
    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }

  save() {
    if (this.editedIndex > -1) {
      const user = this.editedItem;
      const userName = (this.editedItem as any).userName;
      this.$store.dispatch('account/updateUser', { userName, user });
    } else {
      const newUser = this.editedItem;

      this.$store.dispatch('account/createUser', { newUser });
    }
    this.close();
  }

  @Watch('dialog')
  onPropertyChanged(value: any, oldValue: any) {
    if (!value) {
      this.editedItem = Object.assign({}, null);
      this.editedIndex = -1;
    }
  }

  formatFaculties(faculties: any) {
    return faculties.map((e: any) => e.facultyName).join(', ');
  }

  formatUniversityRole(faculties: any) {
    const roles = faculties.filter((e: any) => e.role);

    if (roles && roles.length > 0) {
      return roles.map((e: any) => this.$t(`user.${e.role}`)).join(', ');
    } else {
      return '';
    }
  }

  universityRole(faculty: any) {
    if (faculty.role) {
      return this.$t(`user.${faculty.role}`);
    } else {
      return '';
    }
  }

  removeFaculty(index: any) {
    (this.editedItem as any).faculties.splice(index, 1);
  }

  closeAdd() {
    this.facultyDialog = false;
    this.newFaculty = null;
  }

  addFaculty() {
    (this.newFaculty as any).forEach((faculty: any) => {
      (this.editedItem as any).faculties.push({ facultyId: faculty.id, facultyName: faculty.value });
    });

    this.facultyDialog = false;
    this.newFaculty = null;
  }

  get filterValues() {
    const filter = [];
    if (this.account.search.filter.onlyActive) {
      filter.push({ lookup: this.$t('user.onlyActive'), value: this.$t('general.yes') });
    }

    if (this.account.search.filter.responsibleFacultyKey) {
      filter.push({ lookup: this.$t('user.responsibleFaculty'), value: this.account.search.filter.responsibleFacultyKey.value });
    }

    if (this.account.search.filter.userName) {
      filter.push({ lookup: this.$t('user.userName'), value: this.account.search.filter.userName });
    }

    return filter;
  }

  get faculties() {
    const lookup = this.$store.getters['lookup/getAvailableLookupDetail'](6);
    return lookup
      .filter((item: any) => !item.isDisabled)
      .filter((item: any) => {
        return !(this.editedItem as any).faculties.find((f: any) => f.facultyId === item.id);
      })
      .sort((a: any, b: any) => (a.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') < b.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') ? -1 : 1));
  }
}
